/**
 * streamlines add a dynamic value to left.
 * @param {object} param0
 * @param {number|string} param0.$left
 * @returns {string}
 */
const dynLeft = ({ $left }) => {
  if ($left === undefined) return "";
  if (typeof $left === "number") return `left: ${$left}px;`;
  return `left: ${$left};`;
};

export default dynLeft;
